import React from "react";
import "../styles/home.css";
import Navbar from "../components/BlogNavbar";
import Contact from "../components/ContactSection";
const Home = () => {
  return (
    <div className="home">
      <Navbar />
      <Contact />
    </div>
  );
};

export default Home;
